import router from 'next/router';
import { ApiLoginSuccessAction } from 'lib/store/session/actions';

/**
 * Inspects the given login result success action to see if the account
 * completed the sign-up process. Initiates a redirect to a signup page if not.
 * Skips the redirect and logs an error if no restaurants are found while running
 * in production.
 * The assumption is that the criteria for redirecting to the signup pages
 * should not be met by any accounts in production prior to the rollout of
 * self-serve signup. For this reason an error is logged for any
 * such accounts. We will monitor for this error before self-serve signup
 * is realeased to verify our assumption.
 * Currently it only redirects to the first page of the signup process.
 * In the future this will need to pick a specific point in the self-serve
 * signup process based on the progress made by that user.
 * @param successAction Successful login action
 * @returns true if the checks resulted in a redirect
 */
export default function signupRedirectCheck(
  successAction: ApiLoginSuccessAction,
) {
  // Extra checks to verify types because this is called from plain JS
  if (
    successAction &&
    successAction.type === 'LOGIN_SUCCESS' &&
    Array.isArray(successAction.payload.restaurant_companies) &&
    successAction.payload.restaurant_companies.length === 0
  ) {
    // when adding code that figures out which exact page to redirect to,
    // please consider encapsulating it outside of this function
    router.push('/signup/resume');

    return true;
  }

  return false;
}
